import { CSSObject, Sx } from '@mantine/core';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { ExtendedCustomColors } from 'src/@types';

/** Colors */
export const primaryColorIndex: ExtendedCustomColors = 'eblue.4';

/**  Colors - Icon  */
export function getIconsNormalColor() {
  return COLORS_FLAT.n600;
}
export const iconsNormalIndex: ExtendedCustomColors = 'neutral.7';

export function getHoverColor() {
  // This is also similar to n100. Here for consistency.
  return COLORS_FLAT.b50;
}

/** Colors - Text */

export const blackH = COLORS_FLAT.n901;
export const textNormalIndex: ExtendedCustomColors = 'neutral.9';

/** actual utils */
export function wrapSx(sx: CSSObject): Sx {
  return () => sx;
}
